var e="Select",t="Select.OptionGroup",o="Select.Option";export{t as OPTIONGROUP_DISPLAY_NAME,o as OPTION_DISPLAY_NAME,e as SELECT_DISPLAY_NAME};
//# sourceMappingURL=constants.js.map
